export default __webpack_public_path__ + "static/media/office2-afterA-1440w.9fdf05f0.avif";